export const closeModalOnBgClick = () => {
    document.body.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;

        if (
            target.classList.contains("attrax-popup-modal") &&
            !target.classList.contains("attrax-popup-modal__inner")
        ) {
            target.classList.add("attrax-popup-modal--hidden");
        }
    });
};
